export const formatRelativeTime = (iso, nowMs) => {
  if (!iso) return ''
  const t = new Date(iso).getTime()
  const diff = Math.max(0, nowMs - t)
  const s = Math.floor(diff / 1000)
  if (s < 60) return 'just now'
  const m = Math.floor(s / 60)
  if (m < 60) return `${m}m ago`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}h ago`
  return `${Math.floor(h / 24)}d ago`
}
